import * as React from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 16 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 1.66A1 1 0 0 1 1.468.778l13.863 7.34a1 1 0 0 1 0 1.767L1.468 17.223A1 1 0 0 1 0 16.339z" }));
export {
  SvgPlay as default
};
//# sourceMappingURL=play.js.map
